<a
   class="bg-ten-second text-white rounded rounded-3 text-decoration-none py-2 px-3 d-flex align-items-center col justify-content-center"
   href="{{ url }}"
   target="_blank">
   <i class="material-symbols-outlined me-2">{{ icon }}</i>
   {{ title }}
</a>